import apiClient from '../apiClient';
import { POST_SERVICE_PRICE_URL } from '../apiUrl';

const postServicePrice = (type, data) => {
  return apiClient.post(POST_SERVICE_PRICE_URL(type), data);
};

export default postServicePrice;
